import React from 'react';
import compose from 'lodash/fp/compose';
import { getSimilarUrl } from '@catalogo/service-americanas-product/src/helpers/out-of-stock';
import { SimilarLink } from '@catalogo/ui-americanas-mobile-out-of-stock/src/components/similar-link';
import { withConfig } from '@catalogo/core-connect/config';
import { withMetrics } from '@catalogo/core-metrics';
import { Container, Button, Description, Title } from './styles';
import { getTextByBrand } from './texts';

export const OutOfStockDisclaimer = ({ config, page, dispatchMetrics }) => {
  const brand = config?.brand;
  const { title, description, buttonText } = getTextByBrand(brand);
  const similarUrl = getSimilarUrl(page ? page : {});

  const handleClick = () => {
    dispatchMetrics('event:track', {
      action: 'click',
      category: 'outofstock',
      label: 'relatedProducts',
    });
  };

  return (
    <Container brand={brand}>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <SimilarLink onClick={handleClick} similarUrl={similarUrl}>
        <Button>{buttonText}</Button>
      </SimilarLink>
    </Container>
  );
};

export default compose(withMetrics, withConfig)(OutOfStockDisclaimer);
